module.exports = __webpack_public_path__ + "content/f64b4a6fe8b5437ed345c353cb6e6c25.png";